import React from 'react';
import {useParams} from 'react-router-dom';
import {SplashScreen} from 'packages/common/components/loading-screen';
import {useGetCompanyDetails} from 'packages/common/hooks/api/public/Company';
import {CompanyNotFoundView} from 'apps/public/pages/error/view';

/**
 * Composant validateur qui vérifie l'existence d'une entreprise par son slug
 * et affiche la page d'erreur en conservant le slug dans l'URL
 * @param {object} props - Les props du composant
 * @param {React.ReactNode} props.children - Les enfants à afficher si l'entreprise existe
 * @return {React.ReactNode} Le composant enfant ou la page d'erreur
 */
export default function CompanyValidator({children}) {
  const {slug} = useParams();

  const {
    companyDetails,
    isLoading,
    isError,
  } = useGetCompanyDetails(slug);

  // Afficher le loader pendant le chargement
  if (isLoading) {
    return <SplashScreen />;
  }

  // Afficher la page d'erreur en conservant le slug si erreur ou entreprise non trouvée
  if (isError || !companyDetails) {
    return <CompanyNotFoundView />;
  }

  // Rendre les enfants si l'entreprise existe
  return children;
}
